import React from 'react'
import { FilterOption } from '../../../../components/_WMS/FilterComponent'
import { ComponentProps } from '../../../../types/filters'
import { CourierAutoCompleter } from './CourierAutoCompleter'
import { CourierServiceAutoCompleter } from './CourierServiceAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'courierName',
    label: 'Courier',
    type: 'custom',
    // incluye couriers inactivos: en el mantenedor se necesita poder filtrar por ellos
    Component: (props: ComponentProps) => (
      <CourierAutoCompleter {...props} includeInactive />
    )
  },
  {
    order: 2,
    key: 'courierServiceName',
    label: 'Servicio de Courier',
    type: 'custom',
    // incluye servicios de couriers inactivos: en el mantenedor se necesita poder filtrar por ellos
    Component: (props: ComponentProps) => (
      <CourierServiceAutoCompleter {...props} includeInactive />
    )
  }
]
